import { forwardRef } from "react";
import classNames from "classnames";

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  label: string;
  error?: string;
  className?: string;
  inputClassName?: string;
  showInfo?: boolean;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      type = "text",
      className,
      inputClassName = "bg-transparent",
      showInfo = false,
      disabled = false,
      ...props
    },
    ref
  ) => {
    return (
      <div className={className}>
        <label className="block text-16px font-manrope font-medium text-secondary h-full">
          {label && (
            <span className="block cursor-pointer pb-2.5 text-[16px] font-manrope font-medium text-secondary dark:text-light/70">
              {label}
            </span>
          )}
          <input
            type={type}
            ref={ref}
            disabled={disabled}
            {...props}
            className={classNames(
              "h-full placeholder-other w-full appearance-none text-[16px] font-manrope font-medium rounded-[12px] border border-border bg-transparent px-4 py-2 text-dark ring-[0.5px] ring-light-500 focus:ring-[0.5px] dark:border-dark-600 dark:text-light dark:ring-dark-600 lg:px-5",
              error
                ? "focus:border-[#F44336] !border-[#F44336] focus:ring-[#F44336]"
                : "focus:border-active focus:ring-active dark:focus:border-active dark:focus:ring-active",
              disabled && "!bg-light-200",
              inputClassName
            )}
          />
        </label>
        {showInfo && (
          <span
            role="info"
            className="block pt-2 text-xs text-secondary font-manrope text-[14px] font-medium"
          >
            Enter the 6-digit code from Google Authenticator
          </span>
        )}
        {error && (
          <span
            role="alert"
            className="block pt-2 text-[16px] text-[#F44336] font-manrope"
          >
            {`* ${error}`}
          </span>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
export default Input;
